var map = {
	"./clear-day.png": 435,
	"./clear-night.png": 529,
	"./cloudy.png": 633,
	"./hot.gif": 913,
	"./hot.png": 545,
	"./mist.png": 528,
	"./partly-cloudy-day.png": 261,
	"./partly-cloudy-night.png": 37,
	"./rain.png": 944,
	"./snow.png": 575,
	"./thunderstorm.png": 3
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 460;